import { CheckCircle } from "@mui/icons-material";
import { Grid, Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";
import StyledButton from "./StyledButton";
import KYCGraphics from "src/icons/KYCGraphics";
import { useTheme } from "@mui/styles";
import { trackEvent } from "src/Amplitude";
import usePermission from "src/utils/hooks/usePermission";
import useVerificationNavigation from "../common/useVerificationNavigation";

export default function GuestBanner(props: {
  variant: number;
  descriptionPrefix?: string;
  featureName?: string;
}) {
  let variants = ["Dashboard", "Wallets", "Transactions"];
  const { userPermission } = usePermission();
  const { handleVerification } = useVerificationNavigation();

  useEffect(() => {
    if (userPermission === "guest") {
      trackEvent(`Guest viewed verification banner`, {
        option: variants[props.variant],
      });
    }
  }, []);

  const style = [
    {
      title: `Verify your account now`,
      benefitLines: [
        "Deposit & withdraw funds",
        "Set up watchlists, market trades, and target orders",
        "View your crypto asset holdings & performance at a glance",
        "PLUS much more",
      ],
    },
    {
      title: `Deposit funds to view your ${props.featureName} today!`,
      description: `${props.descriptionPrefix}, you will need to verify your account with the following steps:
      `,
      benefitLines: [
        "Provide some personal information",
        "Upload a proof of address document",
        "Complete our ID verification using a photo ID",
      ],
    },
    {
      title: `Verify your account to view your ${props.featureName} details!`,
      description: `${props.descriptionPrefix}, you will need to verify your account with the following steps:
      `,
      benefitLines: [
        "Provide some personal information",
        "Upload a proof of address document",
        "Complete our ID verification using a photo ID",
      ],
    },
  ];

  const isVariant1or2 = props.variant === 1 || props.variant === 2;
  const theme = useTheme();
  return (
    <Grid
      id="guest-banner"
      container
      sx={{
        padding: "30px",
        borderRadius: "15px",
        boxShadow: isVariant1or2 ? "none" : "0 7px 29px 0 #ff39393d",
        border: isVariant1or2 ? "solid 1px #fc4c4c" : "solid 1px #ff39393d",
        backgroundColor: "white",
        [theme.breakpoints.down(600)]: {
          marginBottom: "10px",
        },
      }}>
      <Grid item xs={12} md={8}>
        {/* Title */}
        <Typography sx={{ fontSize: "28px", fontWeight: "600", paddingBottom: "10px" }}>
          {style[props.variant].title}
        </Typography>

        {/* Description */}
        {isVariant1or2 && <Typography mb={1}>{style[1].description}</Typography>}

        {/* Benefits */}
        {style[props.variant].benefitLines.map((element, iterator) => {
          return (
            <Stack direction={"row"} spacing={1} mb={isVariant1or2 ? 0 : 1} key={iterator}>
              {props.variant === 0 && <CheckCircle sx={{ fontSize: "18px" }} />}
              {isVariant1or2 && <span translate="no">{`${iterator + 1}.`}</span>}
              <Typography sx={{ fontSize: "14px", alignSelf: "center" }}>{element}</Typography>
            </Stack>
          );
        })}
        {/* Button */}
        <StyledButton
          sx={{
            maxWidth: "190px",
            height: "46px",
            marginTop: "18px",
          }}
          onClick={() => handleVerification()}>
          Verify Account now
        </StyledButton>
      </Grid>
      {/* Image */}
      {props.variant === 0 && (
        <Grid
          item
          md={4}
          sx={{
            display: { xs: "none", lg: "flex" },
            justifyContent: "right",
          }}>
          <img
            alt={"kyc_img"}
            src={"./KYCGraphics.png"}
            style={{ width: "165px", height: "208px" }}
          />
        </Grid>
      )}
      {isVariant1or2 && (
        <Grid item md={4} sx={{ display: { xs: "none", lg: "flex" } }}>
          {/* Crypto Lady image */}
          <KYCGraphics />
        </Grid>
      )}
    </Grid>
  );
}
